






















































































































































import { Component, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getInstallListByClient } from '@/api/admin'
import conFirm from './confirm.vue'
import router from '../../router'

@Component({
  components: {
    conFirm
  }
})
export default class Install extends ViewBase {
  loading = true
  errMsg = ''
  total = 0
  page = 1
  pageSize = 10
  list = null
  editItem = {}
  delItem = {}
  editVisible = false
  delVisible = false
  title = ''
  resType = ''
  resTypeList = []
  needStatus = ''
  phaseList = []
  subjectList = []
  dresType = {}
  dphase = {}
  dsubject = {}
  pagination: any = {}
  columns: any = []
  searchkey = ''
  lang = {}
  expandedRowKeys: any = []
  selectedRowKeys: any = []

  visible1 = false
  visible2 = false
  installid = []
  allDeviceIds = []
  doc: any
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  created() {
    this.doc = window.document
    const page = Number(localStorage.getItem('page-install') || 1)
    const pager: any = { ...this.pagination }
    this.page = page
    pager.current = page
    this.pagination = pager
    this.lang = this.i18n.vInstall
    const lang: any = this.lang
    this.columns = [
      {
        title: lang.devices,
        className: 'colName',
        dataIndex: 'cid'
      },
      {
        title: lang.installed,
        className: 'colnum',
        dataIndex: 'doneCount'
      },
      {
        title: lang.installing,
        className: 'colnum',
        dataIndex: 'beingCount'
      },
      {
        title: lang.installFail,
        className: 'colnum',
        dataIndex: 'failCount'
      },
      {
        title: lang.uninstall,
        className: 'colnum',
        dataIndex: 'pendCount'
      },
      {
        title: lang.operation,
        dataIndex: 'operation',
        className: 'texcenter width120',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.fetch({
      page: this.page
    })
  }

  handleTableChange(pagination: any) {
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    localStorage.setItem('page-install', pagination.current)
    this.fetch({
      page: pagination.current
    })
  }

  async fetch(params: any = {}) {
    // console.log('params:', params)
    this.loading = true

    try {
      const { data } = await getInstallListByClient(params)

      const pagination: any = { ...this.pagination }
      // Read total count from server
      // pagination.total = data.totalCount;
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.pagination = pagination

      const rids: any = data.list[0].deviceList || []
      const allDeviceIds: any = []
      if (rids) {
        rids.map((item: any) => {
          allDeviceIds.push(item.id)
        })
      }
      this.allDeviceIds = allDeviceIds
    } catch (ex) {
      this.handleError(ex)
    }
  }
  changegUrl_type(dd: any) {
    // console.log(dd)
    if (dd == 0) {
      this.$router.push({
        name: 'install',
        query: { page: '0' }
      })
    } else {
    }
  }
  onSelectChange(selectedRowKeys: any) {
    // console.log('selectedRowKeys changed: ', selectedRowKeys)
    this.selectedRowKeys = selectedRowKeys
  }
  info(item: any) {
    //  console.log(item)
    this.$router.push({ name: 'installdevresource', params: { id: item.cid + '' } })
    // let dd = []
    // dd.push(item.id)
    // if (this.expandedRowKeys[0] == item.id) {
    //   dd = []
    // }
    // this.expandedRowKeys = dd
  }
  // 各种展示提交操作
  cancelMod() {
    this.visible1 = false
    this.visible2 = false
  }

  oninstallshow(item: any) {
    const id: any = []
    id.push(item.id)
    this.visible1 = true
    this.installid = id
  }
  uninstallshow(item: any) {
    const id: any = []
    id.push(item.id)
    this.visible2 = true
    this.installid = id
  }
  allupdateshow() {
    const id: any = Object.assign([], this.selectedRowKeys)
    // console.log(this.selectedRowKeys)
    if (this.selectedRowKeys.length <= 0) {
      this.$message.error(this.i18n.vInstall.plasechose)
    } else {
      this.visible1 = true
      this.installid = id
    }
  }
  alluninstallshow() {
    const id: any = Object.assign([], this.selectedRowKeys)
    // console.log(this.selectedRowKeys)
    if (this.selectedRowKeys.length <= 0) {
      this.$message.error(this.i18n.vInstall.plasechose)
    } else {
      this.visible2 = true
      this.installid = id
    }
  }
}
